import React from 'react'
import { CrossClientQueryLogicalQuestionDecomposition } from '../../../../models/CrossClient'
import { User } from '../../../../models/User'
import { CrossClientResultSource } from '../../Results/Sources/CrossClientResultSource'
import { CrossClientResultMatch } from './CrossClientResultMatch'
import { getUserDisplayName } from '../../../../apps/professional-app/fa/common/aifeatures/utils'
import { CrossClientResultButtons } from './CrossClientResultButtons'
import { CrossClientQueryResultDetails } from './hooks'
import { CrossClientResultNavButtons } from './CrossClientResultNavButtons'
import { CrossClientResultAnswerExplanation } from './CrossClientResultAnswerExplanation'

export interface CrossClientResultDetailsProps {
  client: User
  decomposition: CrossClientQueryLogicalQuestionDecomposition
  resultDetails: CrossClientQueryResultDetails
}

export const CrossClientResultDetails: React.FC<CrossClientResultDetailsProps> = ({ client, decomposition, resultDetails }) => {
  const { selectedResult, hasNextResult, hasPreviousResult, handleNextResult, handlePreviousResult } = resultDetails

  if (!selectedResult) {
    return null
  }

  const { answers, match, evaluationType } = selectedResult
  const name = getUserDisplayName(client)

  return (
    <div className='d-flex flex-column gap-4 py-2 zocks-mb-2'>
      <div className='d-flex gap-3 p-3 align-items-center justify-content-between zocks-bg-color-gray-100 border border-1 zocks-border-color-gray-300 zocks-border-1.0'>
        <div className='d-flex gap-3 align-items-center'>
          <div className='d-flex flex-column gap-2'>
            <div className='d-flex flex-column gap-1'>
              <div className='d-flex gap-1 align-items-center'>
                <div className='paragraph-medium'>{name}</div>
                <CrossClientResultMatch className='px-2 py-1 gap-1 cross-client-details-match' match={match} iconWidth={12} iconHeight={12} />
              </div>
              <div className='paragraph-small zocks-text-gray-600'>{client?.email ?? ''}</div>
            </div>
            <CrossClientResultButtons result={selectedResult} className='bg-white border border-1 zocks-border-color-gray-300 zocks-border-0.5' withText />
          </div>
        </div>
        <CrossClientResultNavButtons
          hasPreviousResult={hasPreviousResult}
          hasNextResult={hasNextResult}
          handlePreviousResult={handlePreviousResult}
          handleNextResult={handleNextResult}
        />
      </div>
      {!answers ? (
        <div>No data available for this client</div>
      ) : (
        decomposition.atomicClauses.map((clause, index) => {
          const answer = answers[index]
          return (
            <div key={index} className='d-flex flex-column gap-2'>
              <div className='d-flex flex-column gap-1'>
                <div className='d-flex gap-2'>
                  <i className='bi bi-x-diamond-fill zocks-text-info' />
                  <div className='paragraph-medium medium'>{clause.questionForm}</div>
                </div>
                <div className='paragraph-medium ms-1 ps-3'>
                  <CrossClientResultAnswerExplanation answer={answer} match={match} evaluationType={evaluationType} />
                </div>
              </div>
              {answer.source ? <CrossClientResultSource resultSource={answer.source} /> : null}
            </div>
          )
        })
      )}
    </div>
  )
}
